export default "__VITE_ASSET__DizzF0Xj__"